import { Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';
import { useRef, useState } from 'react';
import { MaintenanceBanner } from './maintenance-banner.js';
import { Sidebar } from './sidebar.js';
import { TopBar } from './topbar.js';

/**
 * Coquille de toute page authentifiée (`02` §0) : barre latérale, bandeau
 * maintenance, barre supérieure, contenu de la route active. Posée par la
 * route pathless `_authenticated` (`src/routes/authenticated.tsx`) — les
 * écrans n'ont jamais besoin de la remonter, seulement d'ajouter des routes
 * filles.
 *
 * La barre latérale et l'en-tête (bandeau + barre supérieure) restent fixes
 * au défilement ; le contenu applique les marges de page (16 px mobile,
 * 32 px à partir de `md`).
 */
export function AppShell(): JSX.Element {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar
        mobileOpen={mobileNavOpen}
        onMobileOpenChange={setMobileNavOpen}
        returnFocusRef={menuButtonRef}
      />
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="sticky top-0 z-30">
          <MaintenanceBanner />
          <TopBar
            menuButtonRef={menuButtonRef}
            onMenuClick={() => {
              setMobileNavOpen(true);
            }}
          />
        </div>
        <main className="flex-1 px-4 pb-12 pt-6 md:px-8 md:pt-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
